const state = {
    topnavMsg: {
        isShowCoverDialog: false,
        isShowExportDialog: false,
        isShowSavingMask: false,
        isShowPptMask: false,
        isShowExportSceneList: false,
        savingMaskText: '',
        isShowLogoutMask: false,
        isShowWordCloudDialog: false,
        isShowAnimCourseDialog: false,
        isVersionSwitchNew:false,
        versionSwitchNewType:'切换至新版',
        isInternaInvitation:false,
        isExamineMember:false,
        cover: {
            url: '', // data url window.createURL
            relativeUrl: '', // qi niu filename
            blob: null
        },
        /** 上传封面审核状态 */
        coverForbiddenState: {
          url: '',
          /** 0：审核不通过 1：未审核 2：审核中 3：审核通过 */
          state: 1,
          /** 审核接口返回结果 */
          info: null
        },
        cacheCover: {
            url: '',
            relativeUrl: '',
            blob: null
        },
        transferData: {},
    },
    watermarkInfo: {},
    materialNavReady: false,
}

//获取数据 getters
const getters = {
    TopnavMsg: state => state.topnavMsg,
    Cover: state => state.topnavMsg.cover,
    CoverForbiddenState: state => state.topnavMsg.coverForbiddenState,
    CacheCover: state => state.topnavMsg.cacheCover,
    WatermarkInfo: state => state.watermarkInfo,
    MaterialNavReady: state => state.materialNavReady
}

//修改数据 mutations
const mutations = {
    save_TopnavMsg(state, data = {}) {
        state.topnavMsg = {
            ...state.topnavMsg,
            ...data,
        };
    },
    save_Cover(state, data) {
        let { cover } = state.topnavMsg;
        state.topnavMsg.cacheCover = state.topnavMsg.cover;
        state.topnavMsg.cover = {
            ...cover,
            ...data,
        }
    },
    clear_Cover(state) {
        state.topnavMsg.cacheCover = state.topnavMsg.cover;
        state.topnavMsg.cover = {
            url: '',
            relativeUrl: '',
            blob: null
        }
    },
    save_WatermarkInfo(state, data) {
        state.watermarkInfo = {
            ...state.watermarkInfo,
            ...data
        }
    },
    set_MaterialNavReady(state, data) {
        state.materialNavReady = data
    },
    set_coverForbiddenAudit(state, data) {
      let { coverForbiddenState } = state.topnavMsg;
      coverForbiddenState.url = data.url;
      coverForbiddenState.state = data.state;
      coverForbiddenState.info = data.info;
    }
}

export default {
    state,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/topnav.js